import downloadExcel from './downloadExcel'
export default downloadExcel
